import React from 'react';
import { useDispatch } from 'react-redux';
import { useToasts } from 'react-toast-notifications';
import restApi, { RestApiController } from '../restApi';
import {
  reportUpdate,
  reportNodata,
  reopenReportDialog,
} from '../actions/index';

export default function(data, extraParam) {
  const { addToast } = useToasts();
  const dispatch = useDispatch();

  return React.useMemo(() => {
    const controller = new RestApiController();

    const loadAsync = async () =>
      await new Promise((success, reject) => {
        const { signal } = controller;
        if (signal) {
          signal(reject, this);
        }
        restApi
          .getReportViewAsync(
            data.type,
            data.objectId,
            data.start,
            data.end,
            extraParam,
          )
          .then(json => {
            if (json.ok) {
              dispatch(reportUpdate(data.type, json.data, data));
            } else if (json.code === 404) {
              dispatch(reportNodata(data.type, data));
            }
            success(json);
          })
          .catch(ex => {
            if (ex.reason !== 'canceled') {
              addToast('Възникна грешка при опит да се направи справка', {
                appearance: 'error',
                onDismiss: () => {
                  dispatch(reopenReportDialog(data.type));
                },
              });
              console.error(ex);
            }
            reject(ex);
          });
      });

    return { loadAsync: loadAsync, controller: controller };
  }, [data, extraParam, dispatch, addToast]);
}
